import Vue from 'vue';
import VueBraintree from 'vue-braintree';

// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
Vue.use(VueBraintree);
